import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const DYNAMIC_SERVICES_ENDPOINTS = {
  V1: createEndpoints('v1', {
    ADMIN_DYNAMIC_SERVICES: '/admin/dynamic-services',
    ADMIN_DYNAMIC_SERVICE_DETAIL: (id: number) =>
      `/admin/dynamic-services/${id}`,
    ADMIN_DYNAMIC_SERVICE_ADDITIONS:
      '/admin/dynamic-services/dynamic-service-additions/',
    ADMIN_DYNAMIC_SERVICE_ADDITION_DETAIL: (id: number) =>
      `/admin/dynamic-services/dynamic-service-additions/${id}/`,
    ADMIN_SHOW_TERMS_CHOICES: '/admin/show-terms-choices/',
    ADMIN_COMPLETION_STATUSES: '/admin/completion-statuses/',
    ADMIN_COMPLETION_STATUS_DETAIL: (id: number) =>
      `/admin/completion-statuses/${id}/`,
    ADMIN_BUILDING_DATA_TO_SHOW:
      '/admin/dynamic-services/building-data-to-show',
    UPDATE_SERVICE_ALL_RATIOS: (id: number) =>
      `/admin/dynamic-services/${id}/update-service-all-ratios/`,
    ADDITION_STATUS_CHOICES: '/admin/dynamic-services/addition-status-choices/',
    ADDITION_FIELD_TYPES: '/admin/dynamic-services/addition-field-types/',
    NOTES_DISPLAY_CHOICES: '/admin/notes-display-choices/',
    ADMIN_COLOR_PALETTE: '/admin/completion-statuses/color-palette/',
    SERVICE_COVERAGE_CHECK: '/service-coverage-check',
  }),
} as const;
